<section
  class="mx-3 flex flex-col gap-3 rounded-md border border-gray-200 bg-white p-4"
>
  @if (pack) {
    <app-display-pack-options
      [pack]="pack"
      [usedTrips]="usedTrips"
      [usedUsers]="usedUsers"
    />
  }

  @if (pack && companyId) {
    <app-api-access [companyId]="companyId" [useApi]="pack.useApi" />
  }
</section>
